import { render, staticRenderFns } from "./formapp.vue?vue&type=template&id=c77af584&"
import script from "./formapp.vue?vue&type=script&lang=js&"
export * from "./formapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports